<template>
    <div class="com-record-item discuss-main-item dsp-flex" @click="clickItem" v-bind:class="{'colume-item-gray': parseInt(settingConfigData.showColor) == 0}">
        <div class="com-record-basic discuss-main-basic">
            <p class="discuss-main-item-author" v-if="source.authorName">
                <img class="com-discuss-item-img" v-bind:src="source.authorUrl ? source.authorUrl : avatarUrl" alt="">
                <span class="com-discuss-item-nickname">{{source.authorName}}</span>
            </p>
            <p class="com-record-name discuss-main-item-name">
                <span class="com-discuss-item-sex" v-bind:class="source.bzSexColor">{{source.bzSexText}}</span>
                <span class="com-discuss-item-name">{{source.title.slice(0, 20)}}</span>
            </p>
            <p class="com-record-time discuss-main-item-time">{{source.timeStr}}<i class="iconfont icon-chat"></i>{{source.msgNum}}</p>
        </div>
        <div class="com-record-detail">
            <div class="discuss-main-detail dsp-flex" v-bind:class="{'man': source.bzSexColor=='man', 'woman': source.bzSexColor=='woman', 'direct-rtl': parseInt(settingConfigData.nianyueRishi) == 1}">
                <div class="com-record-word" v-for="(wordValue, index) in source.eightWordArr" v-bind:key="wordValue[0] + wordValue[1] + index">
                    <p v-bind:class="'wd-' + wordValue[0].propXingEn">{{wordValue[0].text}}</p>
                    <p v-bind:class="'wd-' + wordValue[1].propXingEn">{{wordValue[1].text}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { DISCUSS_DOM } from '../../modules/dom'
import { SHARE } from '../../modules/share'
import { WS } from '../../modules/websocket'
export default {
    name: 'DiscussMainItem',
    props: {
        source: {
            type: Object,
            default() { return {} }
        }
    },
    computed: {
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        }
    },
    data() {
        return {
            avatarUrl: require('../../assets/images/avatar.png'),
        }
    },
    methods: {
        clickItem() {
            var me = this,
                curPath = this.$router.history.current.path;
            console.error('clickItem------', this.source, curPath)
            this.$store.state.detail.personInfo = this.source.bz;
            // 设置标题
            this.$store.state.discuss.detailInfo.f_name = this.source.bz.f_name;
            // 先重置，再初始化mini命盘的数据
            this.$store.dispatch("minifatefortune/resetMiniData");
            this.$store.dispatch('minifatefortune/initCommentMiniFateFortune', this.source.bz);

            if(curPath == '/discussmain' || curPath == '/collate') {
                this.$store.state.discuss.hotLunpanData = true;
            }
            // 跳转到论盘详情页面
            let newUrl = '/discuss'+curPath+'/' + this.source.id;
            this.$router.replace(newUrl);
            // 初始化IM
            WS.initWebSocket(this.source.rid, function(){
                // 初始化论盘数据:聊天记录列表:websocket登录之后再拉取列表数据
                me.$store.dispatch("discuss/initLunPan", {
                    lunpanData: me.source,
                    cb: function() {
                        // 设置微信分享配置
                        setTimeout(() => {
                            me.$bus.emit('initDiscussHistoryList');
                            DISCUSS_DOM.updateDiscussPageStyle();
                            DISCUSS_DOM.updateDiscussFormStyle();
                        }, 200);
                        setTimeout(() => {
                            me.$bus.emit('scrollToDiscussBottom');
                            me.$bus.emit('checkDiscussBubbleStatus');
                        }, 1000);
                    }
                });
            });
            
            this.$store.state.discuss.lunpanData = this.source;
            // 配置微信分享
            setTimeout(() => {
                SHARE.initConfigShare();
            }, 20);
        }
    }
}
</script>